import { jsx as _jsx } from "react/jsx-runtime";
import { buildClassName } from '@bluebeam/build-class-name';
import Svg from '../../Svg';
const directionToTailwindMap = {
    down: 'rotate-[270deg]',
    left: 'rotate-0',
    right: 'rotate-180',
    up: 'rotate-90',
};
const ChevronIcon = ({ className, direction, size, ...rest }) => {
    return (_jsx(Svg, { className: buildClassName('transition-transform duration-200', directionToTailwindMap[direction], className), size: size, viewBox: "0 0 24 24", ...rest, children: _jsx("path", { d: "M15.7286 4.21136L8.20148 11.5027C7.92545 11.7931 7.93447 12.2399 8.21974 12.5162L15.7475 19.8068C16.0444 20.0715 16.4976 20.0629 16.7803 19.7891L16.8533 19.7062C17.0719 19.4173 17.0451 19.0138 16.7803 18.7572L9.80364 12.0002L16.7985 5.22487C17.0745 4.93438 17.0655 4.48766 16.7803 4.21136C16.4893 3.92955 16.0195 3.92955 15.7286 4.21136Z", fill: "currentColor" }) }));
};
export default ChevronIcon;
//# sourceMappingURL=ChevronIcon.js.map